import { render, staticRenderFns } from "./EmailCompose.vue?vue&type=template&id=2e4faf46&scoped=true&"
import script from "./EmailCompose.vue?vue&type=script&lang=js&"
export * from "./EmailCompose.vue?vue&type=script&lang=js&"
import style0 from "./EmailCompose.vue?vue&type=style&index=0&id=2e4faf46&prod&lang=scss&"
import style1 from "./EmailCompose.vue?vue&type=style&index=1&id=2e4faf46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4faf46",
  null
  
)

export default component.exports